import { Component } from "react";
import { Container } from 'reactstrap';

export class Cargando extends Component {
    render() {
        return (
            <Container>
                <br /><br />
                <div className="row">
                    <div className="col-12 text-center">
                        <div className="spinner-border" style={{ width: "4rem", height: "4rem" }} role="status">
                        </div>
                    </div>
                </div>
            </Container>
        );
    }
}